module.exports = __webpack_public_path__ + "img/loginRegistration.e9b140e4.png";